import {
    createElement,
    modal,
    loadingGif,
    validateField,
    clearMessage,
    toggleFieldError,
    ConfirmEmailAddress,
    localDatetime,
    uniformClaimDeadline,
    toggleFieldAttributeV2,
} from "commonAssets/js/helpers";
import {
    i18n,
    loading,
    outputDiv,
    reCAPTCHAv3,
} from "commonAssets/js/constants";
import { appPayMethod } from "commonAssets/js/constants";
import {
    DigitalDisbursements,
    dstProcess,
} from "commonAssets/components/FormBase/DigitalDisbursements";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { FormFields } from "commonAssets/components/FormBase/FormFields";

import formDefault from "../docs/formDefault.json"; // Standard Form
import contact_information from "../docs/formDefault/contact_information.json"; // Standard Contact Information
import claim_transactions from "../docs/formDefault/claim_transactions.json"; // Standard Transactional Table
import claim_transactions_amount from "../docs/formDefault/claim_transactions_amount.json"; // Alternate Transactional Table

import { warrantyCalculator } from "./warrantyCalculator";
import WarrantyCleaning from "./warrantyCleaning.js";
import vinCheck from "./customSubmitClaim/vinCheck.mjs";
import { disclaimer } from "./custom";

let formType;
let transactionCount = 0;
let warrantyRow;
let warrantyColumn;
const prevCleaningYears = [];

export const FormFieldsLabel = (field, fieldID, div) => {
    let fieldLabel = i18n.getField(field.label);
    switch (fieldLabel) {
        case "Date":
            if (formType == "submit-claim-form") {
                fieldLabel = "Claim Date";
            } else {
                fieldLabel = "Inquiry Date";
            }
            break;
        case "Service":
            if (formType == "submit-claim-form") {
                fieldLabel = "Claim";
            } else {
                fieldLabel = "Inquiry Claim";
            }
            break;
        case "Vehicle Mileage":
            if (formType == "submit-claim-form") {
                fieldLabel = "Claim Mileage";
            } else {
                fieldLabel = "Inquiry Mileage";
            }
            break;
    }
    const star = field.required ? "*" : "";
    if (
        field.type === "text" ||
        field.type === "autocomplete" ||
        field.type === "number" ||
        field.type === "date" ||
        field.type === "textarea" ||
        field.type === "select"
    ) {
        const label = createElement(
            "label",
            { for: field.name },
            [],
            `${fieldLabel}${star} <span class="error"></span>`
        );
        div.appendChild(label);
    }
};

export class customSubmitClaim extends SubmitClaim {
    async form(page) {
        formType = page;

        // START confirmation email notice
        const textForVinChecker =
            "Please complete this form to: (1) identify whether a vehicle is eligible for extended coverage or the annual sunroof cleaning program, (2) determine the amount of eligible coverage; and (3) obtain necessary information to submit a claim for payment.";
        const textForClaimForm =
            "Please complete this form and attach all relevant documents to submit a claim for payment.";
        const confirmationEmailText =
            '<span class=\'d-block mt-3\'>Please add the email, <span class="fst-italic" id="please_add_confirmation_email">Confirmation@sunroofdrainvinportal.com</span>, to your contact list to ensure that future correspondence is delivered to your inbox.</span>';
        page === "submit-claim-form"
            ? (formDefault.claim_form[
                  this.lang
              ].form_options.claim_form.confirmation_email_notice =
                  textForClaimForm + confirmationEmailText)
            : (formDefault.claim_form[
                  this.lang
              ].form_options.claim_form.confirmation_email_notice =
                  textForVinChecker + confirmationEmailText);
        // END confirmation email notice

        // contact information
        formDefault.claim_form[this.lang].contact_information =
            contact_information;

        // claim transactions
        formDefault.claim_form[this.lang].claim_transactions =
            claim_transactions;

        // START submit claim portal textual changes
        if (page === "submit-claim-form") {
            // console.log(formDefault.claim_form[this.lang].claim_transactions)
            const trxText =
                formDefault.claim_form[this.lang].claim_transactions;
            trxText[0].columns[0].body = "Date of repair.";
            trxText[0].columns[1].body =
                "Covered repair or annual sunroof drain cleaning.";
            trxText[0].columns[2].body =
                "What is the vehicle mileage at the time of the covered repair or annual sunroof drain cleaning?";
            trxText[0].columns[3].body =
                "What is the total amount of the covered repair or annual sunroof drain cleaning?";
            trxText[0].columns[4].body =
                "What dollar amount is the dealer seeking in reimbursement?";
        }
        // END submit claim portal textual changes

        // init the form
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    claim_transactions(params) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement(
            "div",
            {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "transactions",
            },
            [
                createElement(
                    "div",
                    {
                        class: "h3 mb-3 formTitle",
                    },
                    [],
                    params.form_options.transactions.title
                ),
                createElement(
                    "div",
                    {
                        class: "mb-3 formBody",
                    },
                    [],
                    params.form_options.transactions.body
                ),
            ]
        );

        // For Each Transaction Table
        const claim_transactions = params.claim_transactions;
        let tableID = 0;
        claim_transactions.forEach((table) => {
            tableID++; // Begin count at 1.

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", {
                class: "table-responsive mb-3",
                id: "table_responsive_" + tableID,
            });

            // <table class="table transactions"></table>
            const tableTransaction = createElement(
                "table",
                {
                    class: "table table-hover transactions caption-top",
                    id: "transactions_" + tableID,
                    "data-table-name": table.name,
                    "data-table-id": tableID,
                },
                [
                    createElement(
                        "caption",
                        { class: "text-dark bg-transparent" },
                        [],
                        "<strong>" +
                            table.name +
                            "</strong> &mdash; " +
                            table.description
                    ),
                ]
            );
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", {
                class: "table-dark text-light",
            });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach((col) => {
                if (col.claimOnly && formType != "submit-claim-form") return;

                const column = createElement(
                    "th",
                    { scope: "col" },
                    [],
                    col.title
                );
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement(
                        "span",
                        {
                            class: "d-block fw-normal",
                            style: "font-size:16px;",
                        },
                        [],
                        col.body
                    );
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            const countRow = 1;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const add_row = createElement(
                "div",
                {
                    class: "text-center",
                },
                [
                    createElement(
                        "a",
                        {
                            class: "btn btn-primary m-1",
                            id: "add_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label":
                                i18n.getTranslation("transaction_add_row") +
                                table.name,
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-plus-circle" tableID="${tableID}"></i> ${table.name}`
                    ),
                    createElement(
                        "a",
                        {
                            // ada compliance updates - added
                            class: "btn btn-danger m-1 disabled", // default to disabled
                            id: "remove_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label": i18n.getTranslation(
                                "transaction_delete_row"
                            ),
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation("transaction_delete_row")}`
                    ),
                ]
            );

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(
                add_row,
                table,
                tableTBODY,
                tableID,
                countRow
            );

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(add_row);
        });

        return fieldset;
    }

    claim_transaction_row(table, tableTBODY, tableID, countRow) {
        const fieldsRow = createElement("tr", {
            class: "transaction-row", // ada compliance updates - added
            id: "transaction_row_" + tableID + "_" + countRow, // ada compliance updates - added
        });
        if (countRow <= transactionCount) {
            fieldsRow.classList.add("d-none");
        }
        tableTBODY.appendChild(fieldsRow);

        let fieldID = 0;
        table.fields.forEach((field) => {
            fieldID++;
            const td = createElement("td", {
                class: "transaction " + field.name,
            });
            const element = createElement("div");
            const validation = field.validation;

            const formInput = FormFields(
                field,
                "",
                fieldID,
                element,
                validation,
                fieldsRow
            );

            // set unique name for each field
            field.name = field.name + "__" + countRow;
            FormFieldsLabel(field, fieldID, element);

            // set unique id for each field
            formInput.id = formInput.id + "__" + countRow;
            // set item-id attribute
            formInput.setAttribute("item-id", countRow);

            if (countRow <= transactionCount) {
                formInput.disabled = true;
                toggleFieldAttributeV2(formInput, "required", false);
            }

            element.appendChild(formInput);
            td.appendChild(element);
            if (
                field.hidden ||
                (field.claimOnly && formType != "submit-claim-form")
            ) {
                td.classList.add("d-none");
                toggleFieldAttributeV2(formInput, "required", false);
            }
            if (
                field.name.includes("inq-action") &&
                countRow == transactionCount + 1
            )
                formInput.value = formType;
            if (
                field.name.includes("inq-date") &&
                countRow == transactionCount + 1
            )
                formInput.value = new Date().toISOString().split("T")[0];

            fieldsRow.appendChild(td);
        });
        return { tableTBODY, fieldsRow };
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                // Claim Deadline - Default Pacific DateTime
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                // Error Handling
                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                /**
                 * Claim Guard
                 */
                if (form.form_options.notice_confirmation.display === true) {
                    // vinCheck
                    vinCheck(this.claim);

                    // Guard
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    const zero_zero_id =
                        document.getElementById("zero_zero_id");
                    const confirmation_code =
                        document.getElementById("confirmation_code");
                    const skip_guard = document.getElementById("skip-guard");

                    // Notice Id and Confirmation Code
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        input.addEventListener("change", validateField);
                    });

                    // Skip Guard
                    if (skip_guard) {
                        skip_guard.addEventListener("click", () => {
                            // Hide guard
                            // document.getElementById('guard').classList.add("d-none");
                            document.getElementById("guard").remove();
                            // New Claim Form
                            container.appendChild(
                                this.claim_form(form, datetime)
                            );
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);

                            // Init claim fields
                            this.init_claim_fields(
                                this.claim,
                                form,
                                claim_deadline
                            );
                        });
                    }

                    // ada compliance updates - added
                    // if input#submit-guard was clicked add .was-verified to form#guard
                    document
                        .getElementById("submit-guard")
                        .addEventListener("click", () => {
                            document
                                .getElementById("guard")
                                .classList.add("was-validated");
                            // TODO: add required text to labels
                        });

                    // Validate Guard Fields
                    document
                        .getElementById("guard")
                        .addEventListener("submit", (e) => {
                            e.preventDefault();

                            let valid = true;
                            const member = {
                                domain: this.claim.data.domain,
                                zero_zero_id: zero_zero_id.value.toUpperCase(),
                                confirmation_code: confirmation_code.value,
                            };

                            clearMessage();

                            // Validate guard fields
                            [zero_zero_id, confirmation_code].forEach(
                                function (input) {
                                    valid = validateField(input) && valid;
                                }
                            );
                            if (!valid) return;

                            loadingGif(loading, "show");

                            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                            this.claim.api
                                .classMemberPost({}, member)
                                .then((result) => {
                                    // Check for error message
                                    if (result.data.error) {
                                        toggleFieldError(
                                            zero_zero_id,
                                            true,
                                            ""
                                        );
                                        toggleFieldError(
                                            confirmation_code,
                                            true,
                                            ""
                                        );
                                        this.errorHandler.log_exception(
                                            new Error(
                                                "Error loading class member",
                                                { cause: result }
                                            )
                                        );
                                        this.errorHandler.display_modal(result);
                                        return;
                                    }

                                    // Make sure the user is in the correct portal
                                    const path =
                                        window.location.pathname.split("/")[1];
                                    const formMappings = {
                                        // 'vin-check-form': {
                                        //     condition: (result) => result.data.claim_id,
                                        //     message: 'Please use the <strong>Submit Claim</strong> Form for this vehicle.'
                                        // },
                                        // 'submit-claim-form': {
                                        //     condition: (result) => !result.data.claim_id,
                                        //     message: 'Please use the <strong>VIN Check</strong> portal prior to submitting a claim.'
                                        // }
                                    };
                                    const handleFormValidation = (
                                        path,
                                        result
                                    ) => {
                                        const formMapping = formMappings[path];

                                        if (
                                            formMapping &&
                                            formMapping.condition(result)
                                        ) {
                                            modal("Error", formMapping.message);
                                            loadingGif(loading, "hide");
                                            return true; // Indicating the validation failed
                                        }

                                        return false; // Indicating no validation error
                                    };
                                    // If true, show error message
                                    if (handleFormValidation(path, result)) {
                                        return;
                                    }

                                    // Add notice id and confirmation code to claim data
                                    this.claim.data.zero_zero_id =
                                        member.zero_zero_id;
                                    this.claim.data.confirmation_code =
                                        member.confirmation_code;

                                    if (result.data.claim_id) {
                                        this.claim.data.claim_id =
                                            result.data.claim_id;
                                        this.claim.class_member = result.data;
                                        transactionCount =
                                            result.data.claim_transactions.reduce(
                                                (max, item) =>
                                                    Math.max(max, item.item_id),
                                                1
                                            );
                                    } else {
                                        this.claim.class_member = result.data;
                                    }

                                    // Populate claim form
                                    this.populate_claim_form(
                                        form,
                                        container,
                                        result.data,
                                        claim_deadline
                                    );

                                    const previousCleaningsContainer =
                                        document.getElementById(
                                            "previous-cleanings"
                                        );
                                    const previousRepairsContainer =
                                        document.getElementById(
                                            "previous-repairs"
                                        );

                                    // Reset session-level state and UI for
                                    // every lookup, even when there is no
                                    // existing claim history.
                                    prevCleaningYears.length = 0;
                                    if (previousCleaningsContainer) {
                                        previousCleaningsContainer.innerHTML = "";
                                    }
                                    if (previousRepairsContainer) {
                                        previousRepairsContainer.innerHTML = "";
                                    }

                                    if (result.data.claim_id) {
                                        const prevClaimItemIds =
                                            result.data.claim_transactions
                                                .filter(
                                                    (item) =>
                                                        item.name ===
                                                            "Action" &&
                                                        item.value ===
                                                            "submit-claim-form"
                                                )
                                                .map((item) => item.item_id);
                                        const prevCleaningItemIds =
                                            result.data.claim_transactions
                                                .filter(
                                                    (item) =>
                                                        prevClaimItemIds.includes(
                                                            item.item_id
                                                        ) &&
                                                        item.name ===
                                                            "Service" &&
                                                        item.value ===
                                                            "Annual Sunroof Cleaning"
                                                )
                                                .map((item) => item.item_id);
                                        const prevRepairItemIds =
                                            result.data.claim_transactions
                                                .filter(
                                                    (item) =>
                                                        prevClaimItemIds.includes(
                                                            item.item_id
                                                        ) &&
                                                        item.name ===
                                                            "Service" &&
                                                        item.value ===
                                                            "Covered Sunroof Repair"
                                                )
                                                .map((item) => item.item_id);
                                        const prevCleaningDates =
                                            result.data.claim_transactions
                                                .filter(
                                                    (item) =>
                                                        prevCleaningItemIds.includes(
                                                            item.item_id
                                                        ) &&
                                                        item.name === "Date" &&
                                                        item.value !== ""
                                                )
                                                .map((item) => item.value);
                                        const prevRepairDates =
                                            result.data.claim_transactions
                                                .filter(
                                                    (item) =>
                                                        prevRepairItemIds.includes(
                                                            item.item_id
                                                        ) &&
                                                        item.name === "Date" &&
                                                        item.value !== ""
                                                )
                                                .map((item) => item.value);

                                        if (prevCleaningDates.length > 0) {
                                            const cleaningList = createElement(
                                                "ul",
                                                {}
                                            );
                                            prevCleaningDates.forEach(
                                                (date) => {
                                                    const listItem =
                                                        createElement(
                                                            "li",
                                                            {},
                                                            [],
                                                            formatDate(date)
                                                        );
                                                    cleaningList.appendChild(
                                                        listItem
                                                    );
                                                    prevCleaningYears.push(
                                                        new Date(
                                                            date
                                                        ).getUTCFullYear()
                                                    );
                                                }
                                            );
                                            if (previousCleaningsContainer) {
                                                previousCleaningsContainer.appendChild(
                                                    cleaningList
                                                );
                                            }
                                        }

                                        if (prevRepairDates.length > 0) {
                                            const repairList = createElement(
                                                "ul",
                                                {}
                                            );
                                            prevRepairDates.forEach((date) => {
                                                const listItem = createElement(
                                                    "li",
                                                    {},
                                                    [],
                                                    formatDate(date)
                                                );
                                                repairList.appendChild(
                                                    listItem
                                                );
                                            });
                                            if (previousRepairsContainer) {
                                                previousRepairsContainer.appendChild(
                                                    repairList
                                                );
                                            }
                                        }
                                    }
                                })
                                .catch((error) => {
                                    this.errorHandler.log_exception(
                                        new Error(
                                            "Error loading class member",
                                            { cause: error }
                                        )
                                    );
                                    this.errorHandler.display_modal(error);
                                });
                        });
                } else {
                    /**
                     * No Claim Guard
                     */
                    // Edit claim link
                    this.edit_claim(form);

                    // New Claim Form
                    const deadlineSpan = uniformClaimDeadline(claim_deadline);
                    container.appendChild(this.claim_form(form, deadlineSpan));
                    outputDiv.appendChild(container);

                    // Init claim fields
                    this.init_claim_fields(this.claim, form, claim_deadline);
                }

                loadingGif(loading, "hide", 250);
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }

    claim_form(params, additionalParams) {
        console.log("[claim_form]");

        const deadline_heading =
            params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(
            deadline_heading,
            "text/html"
        );
        const deadline_date_string = deadline_string.querySelector("span");

        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement(
            "form",
            {
                class: "needs-validation",
                id: "form",
                method: "post",
            },
            [
                createElement(
                    "h3",
                    {
                        class: "text-center mb-3",
                        id: "claimFormDeadline",
                    },
                    [],
                    deadline_string.body.innerHTML
                ),
                createElement(
                    "div",
                    {
                        class: "alert alert-info text-center fw-bold text-dark",
                        id: "confirmation-email-alert",
                        role: "alert",
                    },
                    [],
                    params.form_options.claim_form.confirmation_email_notice
                ),
                createElement(
                    "div",
                    {},
                    [],
                    `<div class="alert alert-info text-center fw-bold mb-3" role="alert">
                For any questions pertaining to your claim or about the portal,
                please email us at <a href="mailto:info@SunroofDrainVINPortal.com" class="text-primary">info@SunroofDrainVINPortal.com</a>.
            </div>`
                ),
                this.claim_instructions(params),
                this.claim_fieldset(params),
                params.claim_transactions
                    ? this.claim_transactions(params)
                    : ``,
                params.claim_upload.documentation.required
                    ? this.claim_documentation(params)
                    : ``,
                appPayMethod ? DigitalDisbursements(params) : ``,
                this.claim_contact_information(params),
                this.claim_certification(params),
            ]
        );
        return form;
    }

    init_claim_inputs() {
        const claimInputsContact =
            "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST";
        const claimInputsFields =
            "#claim-fields input, #claim-fields textarea, #claim-fields select, #select-cpo-warranty, #date-cpo-warranty-start, #date-cpo-warranty-end";
        const claimInputsFieldsPayment =
            "#payment_method, #payment_token, #payment_email, #payment_phone";
        const claimInputsTransactions =
            "#transactions input, #transactions textarea, #transactions select";

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(claimInputsContact)
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                claimInputsFields + ", " + claimInputsFieldsPayment
            )
        );
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(claimInputsTransactions)
        );
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]");

        /**
         * Prevent the default form submission.
         *
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        // Find fields so we can set the values
        const inServiceDate = claim.inputs.fields.find(
            (field) => field.id === "in_service_date"
        );
        const todaysDate = claim.inputs.transactions.find(
            (field) =>
                field.id.includes(`inq-date__`) &&
                field.id.includes(transactionCount + 1)
        );
        const serviceClaim = claim.inputs.transactions.find(
            (field) =>
                field.id.includes(`inq-service__`) &&
                field.id.includes(transactionCount + 1)
        );
        const vehicleMiles = claim.inputs.transactions.find(
            (field) =>
                field.id.includes(`inq-mileage__`) &&
                field.id.includes(transactionCount + 1)
        );

        // Values are passed to the warranty calculators
        const warranty = warrantyCalculator(
            inServiceDate.value,
            todaysDate.value,
            vehicleMiles.value
        );
        const cleaning = new WarrantyCleaning(
            inServiceDate.value,
            todaysDate.value,
            vehicleMiles.value
        );
        const cleaningWarranty = cleaning.calculator();
        warrantyRow = warranty.row;
        warrantyColumn = warranty.column;

        // Get the fields we want to update
        const coveredByPorsche = document.querySelector(
            "#warranty_covered_by_porsche"
        );
        const extensionProvidedByPorsche = document.querySelector(
            "#warranty_extension_provided_by_porsche"
        );
        const clientIsResponsibleForPayment = document.querySelector(
            "#client_is_responsible_for_payment"
        );
        const eligibleForFreeSunroofDrainClean = document.querySelector(
            "#eligible_for_free_sunroof_drain_clean"
        );

        const inquiryYear = new Date(todaysDate.value).getUTCFullYear();
        const hasPriorCleaningInInquiryYear =
            !Number.isNaN(inquiryYear) &&
            prevCleaningYears.includes(inquiryYear);

        eligibleForFreeSunroofDrainClean.value =
            cleaningWarranty.warrantyStatus === "Valid" &&
            !hasPriorCleaningInInquiryYear
                ? "Yes"
                : "No";

        if (
            formType == "submit-claim-form" &&
            serviceClaim.value == "Annual Sunroof Cleaning"
        ) {
            // For submitted Annual Sunroof Cleaning claims, set current-year
            // eligibility to "No" because the annual cleaning benefit is being
            // consumed by this submission.
            eligibleForFreeSunroofDrainClean.value = "No";
        }

        // Set the values of the fields
        coveredByPorsche
            ? (coveredByPorsche.value = warranty.warrantyStatus)
            : "";
        extensionProvidedByPorsche
            ? (extensionProvidedByPorsche.value =
                  warranty.warrantyPercentage + "%")
            : "";
        clientIsResponsibleForPayment
            ? (clientIsResponsibleForPayment.value =
                  100 - warranty.warrantyPercentage + "%")
            : "";

        // Set the warranty status

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Since: 2023.09.25
         *
         * @returns {void}
         */
        document.getElementById("submit-claim").disabled = true;

        // var claim = this.claim
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        const agentName = document.querySelector(
            `input[data-label="Agent Name"][item-id="${transactionCount + 1}"]`
        );
        const dealerNameTransaction = document.querySelector(
            `input[data-label="Porsche Dealer Name"][item-id="${transactionCount + 1}"]`
        );
        const emailTransaction = document.querySelector(
            `input[data-label="Email Address"][item-id="${transactionCount + 1}"]`
        );

        if (agentName) {
            agentName.value = document.getElementById("signature").value;
        }
        if (dealerNameTransaction) {
            dealerNameTransaction.value =
                document.getElementById("business_name").value;
        }
        if (emailTransaction) {
            emailTransaction.value =
                document.getElementById("email_address").value;
        }

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById("documentation")) {
            this.process_claim_files(this.claim);
        }

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("process", this.claim);
        }

        // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        if (
            appPayMethod &&
            appPayMethod !== "" &&
            this.customDstProcess === null
        ) {
            claim = dstProcess(this.claim);
        } else if (
            appPayMethod &&
            appPayMethod !== "" &&
            this.customDstProcess !== null
        ) {
            claim = this.customDstProcess(this.claim);
        }

        /**
         * Define the environment for the s3 uploader.
         */
        const s3env = this.config.url;

        // Custom process claim
        if (this.customProcessClaim != null) {
            claim = this.customProcessClaim(this.claim);
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise
                .execute(reCAPTCHAv3, { action: "submit" })
                .then((token) => {
                    claim.data.token = token;
                    this.post_claim(claim, s3env);
                });
        } else {
            document.getElementById("submit-claim").disabled = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_form_errors")
            );
        }
    }

    claim_confirmation(params) {
        console.log("[claim_confirmation]");
        // console.log(params)
        const confirmation = createElement(
            "div",
            {
                class: "bg-light text-dark border rounded p-3 mb-3",
                id: "confirmation",
            },
            [
                createElement(
                    "h3",
                    { class: "text-center mb-3" },
                    [],
                    params.confirmation["title"]
                ),
                createElement(
                    "h4",
                    { class: "alert alert-success text-center mb-3" },
                    [],
                    i18n.getTranslation("confirmation_this_is_a_copy")
                ),
                createElement(
                    "p",
                    { class: "text-center text-danger mb-3" },
                    [],
                    params.confirmation.upload_fail
                ),
                createElement(
                    "p",
                    { class: "text-center fw-bold mb-3" },
                    [],
                    params.confirmation.print_note
                ),
                createElement(
                    "h4",
                    { class: "text-center fw-bold mb-3" },
                    [],
                    params.confirmation.claim_details.title
                ),
                createElement(
                    "p",
                    { class: "text-center fw-bold mb-3" },
                    [],
                    params.confirmation.claim_details.body
                ),
                this.confirmation_claim_member(params),
                this.confirmation_claim_fields(params),
                this.confirmation_claim_transactions(params),
                createElement(
                    "div",
                    {
                        class: "row mb-3",
                    },
                    params.confirmation.claim_details.correlation_id
                        ? [
                              createElement(
                                  "div",
                                  { class: "col-6 text-end fw-bold" },
                                  [],
                                  "Correlation ID"
                              ),
                              createElement(
                                  "div",
                                  {
                                      class: "col-6",
                                      id: "confirmation_correlation_id",
                                  },
                                  [],
                                  params.confirmation.claim_details
                                      .correlation_id
                              ),
                          ]
                        : []
                ),
                createElement(
                    "p",
                    { class: "text-center mb-3" },
                    [],
                    params.confirmation.claim_details.footer
                ),
                createElement(
                    "p",
                    { class: "text-center mb-3" },
                    [],
                    params.confirmation.claim_details.edit
                ),
            ]
        );
        return confirmation;
    }

    // claim_confirmation(params) {
    //     console.log('[claim_confirmation]')

    //     // console.log(params)
    //     let confirmation;
    //     if (formType === 'vin-check-form') {
    //         let today = new Date();

    //         let extendedWarrantyEnd = new Date(params.fields['In-Service Date']);
    //         extendedWarrantyEnd.setFullYear(extendedWarrantyEnd.getFullYear() + 6);

    //         let cleanEnd = new Date(params.fields['In-Service Date']);
    //         cleanEnd.setFullYear(cleanEnd.getFullYear() + 9);

    //         confirmation = createElement("div", {
    //             class: "bg-light text-dark border rounded p-3 mb-3",
    //             id: "confirmation",
    //         }, [
    //             createElement("h3", { class: "mb-3" }, [], `VIN: ${params.fields['Vehicle Identification Number (VIN)']}`),
    //             createElement("h3", { class: "mb-3" }, [], `Extended Warranty / Covered Repairs`),
    //             createElement("p", {}, [], `<strong>Extended Warranty end date:</strong> ${formatDate(extendedWarrantyEnd.toISOString().split('T')[0])}`),
    //             createElement("p", {}, [], `<strong>Extended Coverage / Warranty Status:*</strong> ${params.fields['Extended Coverage / Warranty Status']}`),
    //             createElement("p", {}, [], `<strong>Extended Coverage Provided by Porsche:*</strong> ${params.fields['Extended Coverage Provided by Porsche']}`),
    //             createElement("p", {}, [], `<strong>Client is Responsible for Payment:*</strong> ${params.fields['Client is Responsible for Payment']}`),
    //             createElement("table", { id: "warranty-table", class: "mb-3" }, [
    //                 createElement("thead", {}, [
    //                     createElement("tr", {}, [
    //                         createElement("th", { scope: "col" }, [], 'Time from In-Service Date'),
    //                         createElement("th", { scope: "col" }, [], 'Up to 36,000 Miles'),
    //                         createElement("th", { scope: "col" }, [], '36,001 to 50,000 Miles'),
    //                         createElement("th", { scope: "col" }, [], '50,001 to 72,000 Miles'),
    //                         createElement("th", { scope: "col" }, [], '72,001 to 80,000 Miles'),
    //                     ])
    //                 ]),
    //                 createElement("tbody", {}, [
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '3 Years or Less'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '70%'),
    //                         createElement("td", { class: "text-center" }, [], '60%'),
    //                     ]),
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '3-4 Years'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '65%'),
    //                         createElement("td", { class: "text-center" }, [], '55%'),
    //                     ]),
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '4-5 Years'),
    //                         createElement("td", { class: "text-center" }, [], '80%'),
    //                         createElement("td", { class: "text-center" }, [], '70%'),
    //                         createElement("td", { class: "text-center" }, [], '60%'),
    //                         createElement("td", { class: "text-center"}, [], '50%'),
    //                     ]),
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '5-6 Years'),
    //                         createElement("td", { class: "text-center" }, [], '75%'),
    //                         createElement("td", { class: "text-center" }, [], '65%'),
    //                         createElement("td", { class: "text-center" }, [], '55%'),
    //                         createElement("td", { class: "text-center" }, [], '45%'),
    //                     ])
    //                 ])
    //             ]),
    //             createElement("p", { class: "mb-5" }, [], `* information valid at the time of the inquiry`),
    //             createElement("h3", { class: "mb-3" }, [], `Annual Sunroof Drain Clean Program`),
    //             createElement("p", {}, [], `<strong>Annual Sunroof Drain Clean end date:</strong> ${formatDate(cleanEnd.toISOString().split('T')[0])}`),
    //             createElement("p", {}, [], `<strong>Eligible for free Sunroof Drain Clean in the current year:</strong> <span class='cleanEligible${params.fields['Eligible for free Sunroof Drain Clean in the current year']}'>${params.fields['Eligible for free Sunroof Drain Clean in the current year']}</span>`),
    //             params.fields['Does the vehicle have a current/active CPO Warranty?'] == 'YES' ?
    //                 createElement("div", { class: "mt-5" }, [
    //                     createElement("h3", { class: "mb-3" }, [], `ACPO`),
    //                     createElement("p", {}, [], `<strong>ACPO start date:</strong> ${formatDate(params.fields['CPO Warranty Start Date'])}`),
    //                     createElement("p", {}, [], `<strong>ACPO end date:</strong> ${formatDate(params.fields['CPO Warranty End Date'])}`),
    //                 ]) :
    //                 createElement("div", {}, [], ``),
    //         ]);
    //     } else {
    //         let today = new Date();

    //         let extendedWarrantyEnd = new Date(params.fields['In-Service Date']);
    //         extendedWarrantyEnd.setFullYear(extendedWarrantyEnd.getFullYear() + 6);

    //         let cleanEnd = new Date(params.fields['In-Service Date']);
    //         cleanEnd.setFullYear(cleanEnd.getFullYear() + 9);

    //         confirmation = createElement("div", {
    //             class: "bg-light text-dark border rounded p-3 mb-3",
    //             id: "confirmation",
    //         }, [
    //             createElement("h3", { class: "mb-3" }, [], `VIN: ${params.fields['Vehicle Identification Number (VIN)']}`),
    //             createElement("h3", { class: "mb-3" }, [], `Extended Warranty / Covered Repairs`),
    //             createElement("p", {}, [], `<strong>Extended Warranty end date:</strong> ${formatDate(extendedWarrantyEnd.toISOString().split('T')[0])}`),
    //             createElement("p", {}, [], `<strong>Extended Coverage / Warranty Status:*</strong> ${params.fields['Extended Coverage / Warranty Status']}`),
    //             createElement("p", {}, [], `<strong>Extended Coverage Provided by Porsche:*</strong> ${params.fields['Extended Coverage Provided by Porsche']}`),
    //             createElement("p", {}, [], `<strong>Client is Responsible for Payment:*</strong> ${params.fields['Client is Responsible for Payment']}`),
    //             createElement("p", {}, [], `<strong>Invoice Amount:</strong> ${document.querySelector(`input[data-label="Invoice Amount"][item-id="${transactionCount+1}"]`).value}`),
    //             createElement("p", {}, [], `<strong>Claim Amount:</strong> ${document.querySelector(`input[data-label="Claim Amount"][item-id="${transactionCount+1}"]`).value}`),
    //             createElement("table", { id: "warranty-table", class: "mb-3" }, [
    //                 createElement("thead", {}, [
    //                     createElement("tr", {}, [
    //                         createElement("th", { scope: "col" }, [], 'Time from In-Service Date'),
    //                         createElement("th", { scope: "col" }, [], 'Up to 36,000 Miles'),
    //                         createElement("th", { scope: "col" }, [], '36,001 to 50,000 Miles'),
    //                         createElement("th", { scope: "col" }, [], '50,001 to 72,000 Miles'),
    //                         createElement("th", { scope: "col" }, [], '72,001 to 80,000 Miles'),
    //                     ])
    //                 ]),
    //                 createElement("tbody", {}, [
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '3 Years or Less'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '70%'),
    //                         createElement("td", { class: "text-center" }, [], '60%'),
    //                     ]),
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '3-4 Years'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '100%'),
    //                         createElement("td", { class: "text-center" }, [], '65%'),
    //                         createElement("td", { class: "text-center" }, [], '55%'),
    //                     ]),
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '4-5 Years'),
    //                         createElement("td", { class: "text-center" }, [], '80%'),
    //                         createElement("td", { class: "text-center" }, [], '70%'),
    //                         createElement("td", { class: "text-center" }, [], '60%'),
    //                         createElement("td", { class: "text-center"}, [], '50%'),
    //                     ]),
    //                     createElement("tr", {}, [
    //                         createElement("td", {}, [], '5-6 Years'),
    //                         createElement("td", { class: "text-center" }, [], '75%'),
    //                         createElement("td", { class: "text-center" }, [], '65%'),
    //                         createElement("td", { class: "text-center" }, [], '55%'),
    //                         createElement("td", { class: "text-center" }, [], '45%'),
    //                     ])
    //                 ])
    //             ]),
    //             createElement("p", { class: "mb-5" }, [], `* information valid at the time of the inquiry`),
    //             createElement("h3", { class: "mb-3" }, [], `Annual Sunroof Drain Clean Program`),
    //             createElement("p", {}, [], `<strong>Annual Sunroof Drain Clean end date:</strong> ${formatDate(cleanEnd.toISOString().split('T')[0])}`),
    //             createElement("p", {}, [], `<strong>Eligible for free Sunroof Drain Clean in the current year:</strong> <span class='cleanEligible${params.fields['Eligible for free Sunroof Drain Clean in the current year']}'>${params.fields['Eligible for free Sunroof Drain Clean in the current year']}</span>`),
    //             params.fields['Does the vehicle have a current/active CPO Warranty?'] == 'YES' ?
    //                 createElement("div", { class: "mt-5" }, [
    //                     createElement("h3", { class: "mb-3" }, [], `ACPO`),
    //                     createElement("p", {}, [], `<strong>ACPO start date:</strong> ${formatDate(params.fields['CPO Warranty Start Date'])}`),
    //                     createElement("p", {}, [], `<strong>ACPO end date:</strong> ${formatDate(params.fields['CPO Warranty End Date'])}`),
    //                 ]) :
    //                 createElement("div", {}, [], ``),
    //         ]);
    //     }
    //     return confirmation
    // }

    confirmation_claim_transactions(params) {
        const transactions = params.transactions;
        const fieldsContainer = createElement("div", {
            class: "mb-3",
            id: "confirmation_claim_transactions",
        });

        Object.keys(transactions).forEach((index) => {
            Object.keys(transactions[index]).forEach((key) => {
                const fieldLabel = i18n.getField(key);

                if (
                    window.location.pathname.includes("vin-check-form") &&
                    fieldLabel.includes("Claim ")
                ) {
                    return;
                }

                if (transactions[index][key]) {
                    const row = createElement(
                        "div",
                        {
                            class: "row mb-3 pb-3 border-bottom",
                        },
                        [
                            createElement(
                                "div",
                                { class: "col fw-bold text-end" },
                                [],
                                `${fieldLabel} ${index}`
                            ),
                            createElement(
                                "div",
                                { class: "col" },
                                [],
                                transactions[index][key]
                            ),
                        ]
                    );
                    fieldsContainer.appendChild(row);
                }
            });
        });

        const disclaimerRow = createElement("div", { class: "row mb-3" }, [
            createElement("div", { class: "col text-center" }, [
                createElement(
                    "div",
                    { class: "alert alert-info text-center" },
                    [],
                    disclaimer
                ),
            ]),
        ]);
        fieldsContainer.appendChild(disclaimerRow);

        return fieldsContainer;
    }

    // confirmation page
    // confirmation_claim_transactions(params) {
    //     const transactions = params.transactions;
    //     const fieldsContainer = createElement("div", { class: "mb-3", id: "confirmation_claim_transactions" });

    //     Object.keys(transactions).forEach(index => {
    //         Object.keys(transactions[index]).forEach(key => {
    //             let fieldLabel = i18n.getField(key)

    //             if (window.location.pathname.includes('vin-check-form') && fieldLabel.includes('Claim ')) {
    //                 return
    //             }

    //             if (transactions[index][key]) {
    //                 const row = createElement("div", {
    //                     class: "row mb-3 pb-3 border-bottom"
    //                 }, [
    //                     createElement("div", { class: "col fw-bold text-end" }, [], `${fieldLabel} ${index}`),
    //                     createElement("div", { class: "col" }, [], transactions[index][key]),
    //                 ]);
    //                 fieldsContainer.appendChild(row);
    //             }
    //         });
    //     })

    //     const disclaimerRow = createElement("div", { class: "row mb-3" }, [
    //         createElement("div", { class: "col text-center" }, [
    //             createElement("div", { class: "alert alert-info text-center" }, [], disclaimer)
    //         ])
    //     ]);
    //     fieldsContainer.appendChild(disclaimerRow);

    //     return fieldsContainer;
    // }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        // remove localStorage items
        const localStorageItemsToRemove = {
            warrantyClaim: "warrantyClaimForm",
            submitClaim: "submitClaimForm",
        };

        // Remove localStorage items
        const removeLocalStorageItems = () => {
            for (const key in localStorageItemsToRemove) {
                const formKey = localStorageItemsToRemove[key];

                if (
                    localStorage.getItem(key) &&
                    localStorage.getItem(formKey)
                ) {
                    localStorage.removeItem(key);
                    localStorage.removeItem(formKey);
                }
            }
        };
        removeLocalStorageItems();

        if (claim.flags.success) {
            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector("div.display-form").classList.add("d-none");

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            //document.querySelector(`#warranty-table tbody tr:nth-of-type(${warrantyRow}) td:nth-of-type(${warrantyColumn+1})`).style.backgroundColor = 'yellow';
            outputDiv.scrollIntoView({ behavior: "smooth" });
        } else {
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_submit_error")
            );
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (const type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(
            document.querySelectorAll('input[type="radio"]'),
            function (radio) {
                radio.setAttribute("disabled", "disabled");
            }
        );

        document
            .getElementById("submit-claim")
            .setAttribute("disabled", "disabled");
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}

function formatDate(inputDate) {
    const [year, month, day] = inputDate.split("-");
    return `${month}/${day}/${year}`;
}
